export default {
  "challenge_friend": "UTMANA EN KOMPIS!",
  "correct_answer": "Rätt svar",
  "get_ready": "GÖR DIG REDO!",
  "get_ready_information": "Quizet går på tid - ju snabbare du svarar,\ndesto mer poäng får du.",
  "point": "POÄNG!",
  "quiz_steps": "FRGÅR %d AV 10",
  "scan_qr_code": "Skanna QR-koden med din mobilkamera för att skicka ett sms med utmaningen till en vän.",
  "total_answers_right": "Du svarade rätt på <span style='color:#FFDE00'>%d av 10 frågor</span> och fick totalt",
  "bad_score": "Ojdå!",
  "good_score": "Bättre kan du!",
  "neat_score": "Snyggt!",
  "wonderful_score": "Wow!",
  "score_point_text": "Tryck på <b>Välj quiz</b> nedan för att<br/> testa dina kunskaper i ett annat quiz.",
  "startar": "Startar",
  "downloading": "Laddar ner innehåll:"
};
